import React from "react";

const InPlay = () => {
  return (
    <div>
      <div className="Inplay_container bg-[#fff] mt-1">
        <div className="title_inplay_game  text-white p-[3px] ">
          <h2 className="font-bold">Cricket</h2>
        </div>
        <div className="bar_light flex justify-end bg-gray-400">
          <div></div>
          <div className="flex justify-between hide_part_mobile w-[290px] mr-[95px]">
            <div>1</div>
            <div>x</div>
            <div>2</div>
          </div>
        </div>
        <div className="gamelist  items-center flex justify-between">
          <div className="event_info">
            <div className="gamelist_col-8 ">
              <div className="p- cursor-pointer">
                <span className="game-list-time mt-1 items-center flex">
                  <img
                    src="./img/ICONS/Video_Icon.png"
                    className="w-[15px] h-[15px] ml-2"
                    alt=""
                  />
                  <img
                    src="./img/ICONS/20230511_201058_0003 (1).png"
                    className="w-[15px] h-[15px] ml-2"
                    alt=""
                  />

                  <span className="in_plays text-[#508d0e] font-bold mx-2">
                    In-Play
                  </span>
                </span>
              </div>
              <div className="flex items-center">
                <div className=" ">
                  <img
                    src="./img/ICONS/Clock_Icon_BG.png"
                    className="icons w-[10px] ml-2 mr-2"
                    alt=""
                  />
                </div>
                <a
                  href=""
                  className="text-[#2789ce] text-decoration-none capitalize font-bold hover:underline"
                >
                  India vs Pakistan
                </a>
              </div>
            </div>
          </div>
          <div className="right_back_lay items-center flex justify-end gap-[0.5rem]">
            <div className="col_mateched hide_part_mobile">PTED</div>
            <div className="col_visit w-[144px] hide_part_mobile flex justify-between">
              <a
                href=""
                className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#72bbef] "
              >
                1.41
              </a>
              <a
                href=""
                className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#faa9ba]"
              >
                2.14
              </a>
            </div>
            <div className="col_draw w-[130px] hide_part_mobile flex justify-between">
              <a
                href=""
                className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#72bbef]"
              >
                1.41
              </a>
              <a
                href=""
                className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#faa9ba]"
              >
                2.14
              </a>
            </div>
            <div className="col_home w-[130px] hide_part_mobile flex justify-between">
              <a
                href=""
                className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#72bbef]"
              >
                1.41
              </a>
              <a
                href=""
                className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#faa9ba]"
              >
                2.14
              </a>
            </div>
            <div className="col_info">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
                <path
                  fill="#7E97A7"
                  d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="Inplay_container bg-[#fff] mt-3 ">
        <div className="title_inplay_game text-white p-[3px] bg-[#243a48]">
          <h2 className="font-bold">Soccer</h2>
        </div>
        <div className="bar_light flex justify-end bg-gray-400">
          <div></div>
          <div className="flex justify-between hide_part_mobile w-[290px] mr-[95px]">
            <div>1</div>
            <div>x</div>
            <div>2</div>
          </div>
        </div>
        {[1, 2, 3, 4, 5, 6].map((ele, i) => {
          return (
            <div className="gamelist  items-center flex justify-between">
              <div className="event_info">
                <div className="gamelist_col-8 ">
                  <div className="p- cursor-pointer">
                    <span className="game-list-time mt-1 items-center flex">
                      <img
                        src="./img/ICONS/Video_Icon.png"
                        className="w-[15px] h-[15px] ml-2"
                        alt=""
                      />
                      <img
                        src="./img/ICONS/20230511_201058_0003 (1).png"
                        className="w-[15px] h-[15px] ml-2"
                        alt=""
                      />

                      <span className="in_plays text-[#508d0e] font-bold mx-2">
                        In-Play
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center">
                    <div className=" ">
                      <img
                        src="./img/ICONS/Clock_Icon_BG.png"
                        className="icons w-[10px] ml-2 mr-2"
                        alt=""
                      />
                    </div>
                    <a
                      href=""
                      className="text-[#2789ce] text-decoration-none capitalize font-bold hover:underline"
                    >
                      India vs Pakistan
                    </a>
                  </div>
                </div>
              </div>
              <div className="right_back_lay items-center flex justify-end gap-[0.5rem]">
                <div className="col_mateched hide_part_mobile">PTED</div>
                <div className="col_visit w-[144px] hide_part_mobile flex justify-between">
                  <a
                    href=""
                    className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#72bbef] "
                  >
                    1.41
                  </a>
                  <a
                    href=""
                    className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#faa9ba]"
                  >
                    2.14
                  </a>
                </div>
                <div className="col_draw w-[130px] hide_part_mobile flex justify-between">
                  <a
                    href=""
                    className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#72bbef]"
                  >
                    1.41
                  </a>
                  <a
                    href=""
                    className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#faa9ba]"
                  >
                    2.14
                  </a>
                </div>
                <div className="col_home w-[130px] hide_part_mobile flex justify-between">
                  <a
                    href=""
                    className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#72bbef]"
                  >
                    1.41
                  </a>
                  <a
                    href=""
                    className="w-[71px] text-center font-semibold text-sm py-[10px] bg-[#faa9ba]"
                  >
                    2.14
                  </a>
                </div>
                <div className="col_info">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                  >
                    <path
                      fill="#7E97A7"
                      d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InPlay;
